
namespace RioERP.Reports {
    export class GstReportSummaryWithGstinColumns {
        static columnsKey = 'Reports.GstReportSummaryWithGstin';
    }
}